// Lane B (10/15/26) customer words. Drafted by Astra (GPT-6, copy lane), gated by Claude against AGENTS.md.
// B-136: the When chip for today through the next 6 days. Astra: "Coming week" ("signals a rolling seven-day window
// without implying the calendar-week cutoff of 'This week'"); its alternative was "7 days".
// 10/15 Alvin overrode it: "What if we say \"next 7 days\"?" (his exact label, not an Astra draft).
const COPY = {
  'filter.week': 'Next 7 days',
} as const

export type LaneBKey = keyof typeof COPY
export const lb = (key: LaneBKey): string => COPY[key]
